module.exports = __webpack_public_path__ + "static/media/banner-2.1cc9ca14.png";